import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-72a530b1")

_pushScopeId("data-v-72a530b1")
const _hoisted_1 = { class: "admin-contract" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h3", { class: "title" }, "契約一覧", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "新規契約", -1)
const _hoisted_5 = { class: "checkboxpane" }
const _hoisted_6 = { class: "admin-header1 checkboxpane" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "header-type checkboxpane" }, "契約種別：", -1)
const _hoisted_8 = { class: "admin-header1 checkboxpane" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "header-status checkboxpane" }, "契約状態：", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  src: "/icons/green.svg",
  class: "checkboxpane miniIcon"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "header-status checkboxpane" }, "期限まで1ヵ月以上", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  src: "/icons/yellow.svg",
  class: "checkboxpane miniIcon"
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "header-status checkboxpane" }, "期限切れ/期限まで1ヵ月未満", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  src: "/icons/red.svg",
  class: "checkboxpane miniIcon"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "header-status checkboxpane" }, "利用停止(期限に関わらず)", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_17 = { class: "admin-header2" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "type" }, "契約種別", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "status" }, "契約状態", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "company-name" }, "会社名/部署名", -1)
const _hoisted_21 = { class: "range" }
const _hoisted_22 = /*#__PURE__*/_createVNode("span", null, "契約期間", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "plan" }, "ユーザー数上限", -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "commands" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CheckBox = _resolveComponent("CheckBox")
  const _component_InputSort = _resolveComponent("InputSort")
  const _component_AdminContractItem = _resolveComponent("AdminContractItem")
  const _component_AdminContractEdit = _resolveComponent("AdminContractEdit")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("button", {
        class: "primary-button",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toCreate && _ctx.toCreate(...args)))
      }, [
        _hoisted_4
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_CheckBox, {
          label: "本契約",
          checked: _ctx.isDefaultChecked,
          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.agreeChecked($event.target.checked))),
          isShowModal: _ctx.isShowEdit,
          "onUpdate:isShowModal": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShowEdit = $event))
        }, null, 8, ["checked", "isShowModal"]),
        _createVNode(_component_CheckBox, {
          label: "トライアル",
          checked: _ctx.isDefaultChecked,
          onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.trialChecked($event.target.checked))),
          isShowModal: _ctx.isShowEdit,
          "onUpdate:isShowModal": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isShowEdit = $event))
        }, null, 8, ["checked", "isShowModal"])
      ]),
      _createVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_CheckBox, {
          label: "",
          checked: _ctx.isDefaultChecked,
          onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.validityChecked($event.target.checked))),
          isShowModal: _ctx.isShowEdit,
          "onUpdate:isShowModal": _cache[7] || (_cache[7] = ($event: any) => (_ctx.isShowEdit = $event))
        }, null, 8, ["checked", "isShowModal"]),
        _hoisted_10,
        _hoisted_11,
        _createVNode(_component_CheckBox, {
          label: "",
          checked: _ctx.isDefaultChecked,
          onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.nearExpireChecked($event.target.checked))),
          isShowModal: _ctx.isShowEdit,
          "onUpdate:isShowModal": _cache[9] || (_cache[9] = ($event: any) => (_ctx.isShowEdit = $event))
        }, null, 8, ["checked", "isShowModal"]),
        _hoisted_12,
        _hoisted_13,
        _createVNode(_component_CheckBox, {
          label: "",
          checked: _ctx.isDefaultChecked,
          onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.disabledChecked($event.target.checked))),
          isShowModal: _ctx.isShowEdit,
          "onUpdate:isShowModal": _cache[11] || (_cache[11] = ($event: any) => (_ctx.isShowEdit = $event))
        }, null, 8, ["checked", "isShowModal"]),
        _hoisted_14,
        _hoisted_15
      ])
    ]),
    _hoisted_16,
    _createVNode("div", _hoisted_17, [
      _hoisted_18,
      _hoisted_19,
      _hoisted_20,
      _createVNode("div", _hoisted_21, [
        _hoisted_22,
        _createVNode(_component_InputSort, {
          class: "toggle",
          type: "button",
          label: "新しい順",
          checked: _ctx.isOrderAsc,
          onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.sortByAsc(_ctx.contracts, $event)))
        }, null, 8, ["checked"]),
        _createVNode(_component_InputSort, {
          class: "toggle",
          type: "button",
          label: "古い順",
          checked: !_ctx.isOrderAsc,
          onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.sortByDesc(_ctx.contracts, $event)))
        }, null, 8, ["checked"])
      ]),
      _hoisted_23,
      _hoisted_24
    ]),
    _createVNode(_component_AdminContractItem, { isHeader: true }),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.contracts, (contract) => {
      return _withDirectives((_openBlock(), _createBlock(_component_AdminContractItem, {
        class: "list-item",
        key: contract.id,
        item: contract,
        onUsers: _ctx.toUsers,
        onEdit: _ctx.toEdit,
        onStop: _ctx.toStop,
        onRestart: _ctx.toRestart,
        onDelete: _ctx.toDelete
      }, null, 8, ["item", "onUsers", "onEdit", "onStop", "onRestart", "onDelete"])), [
        [_vShow, _ctx.filter(contract)]
      ])
    }), 128)),
    _createVNode(_component_AdminContractEdit, {
      isShowModal: _ctx.isShowEdit,
      "onUpdate:isShowModal": _cache[14] || (_cache[14] = ($event: any) => (_ctx.isShowEdit = $event)),
      editMode: _ctx.editMode,
      editModel: _ctx.editingModel,
      onApply: _ctx.apply,
      onRemove: _ctx.remove
    }, null, 8, ["isShowModal", "editMode", "editModel", "onApply", "onRemove"])
  ]))
})